import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const setDiscountRuleActive = {
  name: "setDiscountRuleActive" as const,
  input: z.object({ ruleId: zExt.objectId(), active: z.boolean() }),
  output: z.null(),
};
